export default __webpack_public_path__ + "static/char-v-57-ja-c73acaa2eb6fa3deade90adf1d249229.mp4";